import { SummaryBlocks } from '../types';
import { assumptionsLayout } from './assumptions';
import { buildCardSections } from './buildCardSections';
import { buildSections } from './buildSections';
import { CardResolver } from './cardTypes';
import { detailsLayout } from './details';
import { DevelopmentResolver, developmentLayout } from './development';
import { forecastLayout } from './forecast';
import {
    AssumptionsMetricId, DetailsMetricId, ForecastMetricId, OperationsMetricId, ReturnsMetricId,
} from './metrics';
import { operationsLayout } from './operations';
import { returnsLayout } from './returns';
import { BlockResolver, LayoutContext } from './types';

export interface ApartmentResolvers {
    details: CardResolver<DetailsMetricId>;
    assumptions: BlockResolver<AssumptionsMetricId>;
    forecast: BlockResolver<ForecastMetricId>;
    returns: BlockResolver<ReturnsMetricId>;
    development: DevelopmentResolver;
    operations: BlockResolver<OperationsMetricId>;
}

export const buildBlocks = (context: LayoutContext, resolvers: ApartmentResolvers): SummaryBlocks => ({
    details: buildCardSections(detailsLayout(context), resolvers.details),
    assumptions: buildSections(assumptionsLayout(context), resolvers.assumptions),
    forecast: buildSections(forecastLayout(), resolvers.forecast),
    returns: buildSections(returnsLayout(), resolvers.returns),
    development: buildSections(developmentLayout(resolvers.development), resolvers.development),
    operations: buildSections(operationsLayout(context), resolvers.operations),
});
